import { render, staticRenderFns } from "./beneficiary-bill-payment-bill-corp.vue?vue&type=template&id=5e6c3730&"
import script from "./beneficiary-bill-payment-bill-corp.vue?vue&type=script&lang=js&"
export * from "./beneficiary-bill-payment-bill-corp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports